import request from '@/plugins/http';
// 落地页套餐列表，通用套餐接口，同漫游卡、美国本地套餐接口
export const bundleList = (data) => {
  return request({
    url: '/api/v1/order/bundleList',
    method: 'post',
    data
  });
};

// 选择套餐
export const bundleCheckOut = (data) => {
  return request({
    url: '/api/v1/promotion/bundleCheckOut',
    method: 'post',
    params: data.uuid,
    data: data.data
  });
};

// 选择套餐后弹框 选择有卡或无卡，确认时调用
export const confirmCard = (data) => {
  return request({
    url: '/api/v1/promotion/confirmCard',
    method: 'post',
    data: data
  });
};

// 订单询价
export const orderInquiry = (data) => {
  return request({
    url: '/api/v1/order/orderInquiry',
    method: 'post',
    data: data
  });
};

// 信息填写支付
export const orderDoPay = (data) => {
  return request({
    url: '/api/v1/promotion/orderDoPay',
    method: 'post',
    data: data
  });
};

// 支付结果
export const orderSuccess = (orderNo) => {
  return request({
    url: '/api/v1/promotion/orderSuccess/' + orderNo,
    method: 'get'
  });
};
